import { z } from 'zod';

/**
 * GET /api/config, public (R13 plus ADDENDUM A9 item 9). Every response also carries
 * X-App-Version. A client below `minClient` shows the blocking "New version required" screen.
 */
export const ConfigResZ = z.object({
  version: z.string(),
  minClient: z.string(),
  crewName: z.string(),
  crewTz: z.string(),
  /** VAPID public key (base64url) or null when push is off. */
  vapidKey: z.string().nullable(),
  pushEnabled: z.boolean(),
  aiEnabled: z.boolean(),
  /** 'mock' when no AI key is set. */
  aiProvider: z.enum(['fal', 'openai', 'mock']),
  mcpEnabled: z.boolean(),
  bootstrapNeeded: z.boolean(),
  serverNow: z.number().int(),
});
export type ConfigRes = z.infer<typeof ConfigResZ>;
